module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirt-Rakuten.3b1c1a14.svg";